var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 1.2C7.46863 1.2 7.2 0.931371 7.2 0.6C7.2 0.268629 7.46863 0 7.8 0H11.4C11.7314 0 12 0.268629 12 0.6V4.2C12 4.53137 11.7314 4.8 11.4 4.8C11.0686 4.8 10.8 4.53137 10.8 4.2V2.04853L7.62426 5.22426C7.38995 5.45858 7.01005 5.45858 6.77574 5.22426C6.54142 4.98995 6.54142 4.61005 6.77574 4.37574L9.95147 1.2H7.8ZM4.37574 6.77574C4.61005 6.54142 4.98995 6.54142 5.22426 6.77574C5.45858 7.01005 5.45858 7.38995 5.22426 7.62426L2.04853 10.8H4.2C4.53137 10.8 4.8 11.0686 4.8 11.4C4.8 11.7314 4.53137 12 4.2 12H0.6C0.268629 12 0 11.7314 0 11.4V7.8C0 7.46863 0.268629 7.2 0.6 7.2C0.931371 7.2 1.2 7.46863 1.2 7.8V9.95147L4.37574 6.77574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconWhite);
export default __webpack_public_path__ + "static/media/expandIconWhite.77f55bb90795929d07576114953705a9.svg";
export { ForwardRef as ReactComponent };